<template>
  <!--自助门禁    列表-->
  <div>
    <ul class="pz_two">
      <!-- <li @click="bindNext()">
        <p class="type">北一门入口</p>
        <p>门禁模式：统计门禁</p>
        <p>限次模式：不限</p>
        <p>开始时间：2023/10/31</p>
      </li> -->
      <li
        v-for="(page, index) in pagedData"
        :key="index"
        @click="toCheckin(page)"
      >
        <p class="type">{{ page.accessControlName }}</p>
        <p>门禁模式：{{ getAccessControlMode(page.accessControlMode) }}</p>
        <p>限次模式：{{ getLimitMode(page.limitMode) }}</p>
        <p>开始时间：{{ dateFormat(page.beginTime) }}</p>
        <p>结束时间：{{ dateFormat(page.endTime) }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "",
  components: {},
  data() {
    return {
      accessControlPoints: [],
      currentPage: 0, // 当前页码
      itemsPerPage: 4, // 每页显示的元素数量
    };
  },
  computed: {
    pagedData() {
      // 使用computed计算属性来获取分页后的数据
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.accessControlPoints.slice(start, end);
    },
  },
  mounted() {
    const alias = this.$route.query.alias;
    !!alias && this.getAccessControlPoints(alias);
  },
  methods: {
    getAccessControlMode(mode) {
      switch (mode) {
        case 1:
          return "统计门禁";
        case 2:
          return "验证门禁";
        case 3:
          return "人像门禁";
        case 4:
          return "进出门禁";
      }
    },
    getLimitMode(mode) {
      switch (mode) {
        case 0:
          return "不限";
        case 1:
          return "单日";
        case 2:
          return "展期";
        case 3:
          return "任一日";
      }
    },
    dateFormat(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      if (
        this.currentPage <
        this.accessControlPoints.length / this.itemsPerPage
      ) {
        this.currentPage += 1;
      }
    },
    async getAccessControlPoints(alias) {
      const res = await this.$get(
        `/api/AccessControl/GetAccessControlPoints/${alias}`
      );
      if (res.code === 200 && res.data.length > 0) {
        this.accessControlPoints = [...res.data];
      }
    },
    toCheckin(item) {
      const { alias, id } = item;
      this.$router.push(`/access-control/checkin?alias=${alias}&point=${id}`);
    },
  },
};
</script>

<style></style>
